import {React, useState, useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // استایل‌های پیش‌فرض Swiper
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Row, Col } from "react-bootstrap";
import UseMediaQuery from "./UseMediaQuery";


import banner from '../img/slider/banner.png';
import mobileBanner from '../img/slider/mobile-banner.png';

const Slider = () => {
    const isMobile = UseMediaQuery("(max-width: 768px)");

    return (
        <Swiper
       
        slidesPerView={1}
        pagination={{ clickable: true }}
        loop
        >
            <SwiperSlide>
                <div className="banner-i" style={{
                    backgroundImage: `url(${isMobile ? mobileBanner : banner})`
                }}>
                
                        <Row className="justify-content-center text-center">
                        <Col>
                            <h1 className="title-banner">کیمیا گالری</h1>
                            <p className="drc-banner">کلیه محصولات گالری کیمیا طلای 18 عیار می باشد.</p>
                            
                        </Col>
                        </Row>
                
                </div>
            </SwiperSlide>
        {/*<SwiperSlide>
            <img src="https://via.placeholder.com/800x400" alt="Slide 2" />
        </SwiperSlide>
        <SwiperSlide>
            <img src="https://via.placeholder.com/800x400" alt="Slide 3" />
        </SwiperSlide>*/}
        </Swiper>
    );
};

export default Slider;